import { initializeApp } from "firebase/app";

// const firebaseConfig = {
//   apiKey: "AIzaSyBM2ykHjlP8UnfkPTyeS1cC4Vd6YetamF0",
//   authDomain: "mroczkowski-well.firebaseapp.com",
//   databaseURL: "https://mroczkowski-well-default-rtdb.europe-west1.firebasedatabase.app/",
//   projectId: "mroczkowski-well",
//   storageBucket: "mroczkowski-well.appspot.com",
//   messagingSenderId: "457568679317",
//   appId: "1:457568679317:web:02af2ca8a0efe2a14a729c"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDIJSeGIWo4y1NZKjjxbx-8usSBRCA4xu4",
  authDomain: "kalendarz-a4c58.firebaseapp.com",
  databaseURL: "https://kalendarz-a4c58-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kalendarz-a4c58",
  storageBucket: "kalendarz-a4c58.appspot.com",
  messagingSenderId: "649395435839",
  appId: "1:649395435839:web:da2541bf36102faff2bb8a"
};

const fc = initializeApp(firebaseConfig);

export default fc;